/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, Input, TemplateRef, ViewChild, ViewContainerRef, ChangeDetectionStrategy} from '@angular/core';
import {Clipboard} from '@angular/cdk/clipboard';
import {timer} from 'rxjs';
import {sharedComponentsConfiguration} from '../shared-components-configuration';

@Component({
    selector: 'app-copy-paste',
    templateUrl: './copy-paste.component.html',
    styleUrls: ['./copy-paste.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CopyPasteComponent {
    @ViewChild('copyAnimationTemplate', {read: TemplateRef}) templateAnimation: TemplateRef<HTMLTemplateElement>;
    @ViewChild('copyAnimationView', {read: ViewContainerRef}) copyAnimationView: ViewContainerRef;
    @Input() copyText: string;
    @Input() backgroundColor: string;
    @Input() buttonAlignRight = false;
    showCopyPaste = false;

    constructor(private clipboard: Clipboard) {
    }

    get showCopyPasteButton(): boolean {
        return this.copyText != null && this.showCopyPaste;
    }

    showCopyPastAction(showButton: boolean): void {
        this.showCopyPaste = showButton;
    }

    copySettlementTableClick(event: Event, copyValue: string): void {
        event?.stopPropagation();
        if (copyValue != null) {
            this.clipboard.copy(copyValue);
            this.copyAnimationView?.createEmbeddedView(this.templateAnimation);
            timer(sharedComponentsConfiguration.animationTimeout)
                    .subscribe(() => {
                        this.copyAnimationView?.remove(0);
                    });
        }
    }
}
